/**
 * Game over screen component.
 * Displays when the Builder unit dies.
 */

import { useEffect } from 'react';
import { useGameStateStore } from '@shared/stores';

export default function GameOverScreen() {
  const { returnToMenu } = useGameStateStore();

  useEffect(() => {
    // Auto-return to main menu after 3 seconds
    const timer = setTimeout(() => {
      returnToMenu();
    }, 3000);

    return () => clearTimeout(timer);
  }, [returnToMenu]);

  return (
    <div className="absolute inset-0 z-50 bg-gray-900 bg-opacity-95 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-white mb-4">Game Over</h1>
        <p className="text-xl text-gray-300 mb-8">Your builder has been eliminated!</p>
        <p className="text-sm text-gray-400">Returning to main menu in 3 seconds...</p>
      </div>
    </div>
  );
}
